import { render, staticRenderFns } from "./paid-parent.vue?vue&type=template&id=594f59dc"
import script from "./paid-parent.vue?vue&type=script&lang=ts"
export * from "./paid-parent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports